/**
 * Supported languages in the application
 */
export type SupportedLanguage = 'en' | 'es' | 'fr' | 'de' | 'pt';

/**
 * Language configuration with display names
 */
export interface LanguageOption {
  code: SupportedLanguage;
  name: string;
  nativeName: string;
}

/**
 * Available languages with their display names
 */
export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português' },
];

/**
 * Default fallback language
 */
export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

/**
 * LocalStorage key for persisting language preference
 */
export const LANGUAGE_STORAGE_KEY = 'dineflow-language';
